import { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);       // user object when authenticated
  const [status, setStatus] = useState("checking"); // 'checking' | 'setup' | 'authed' | 'guest'

  const bootstrap = async () => {
    try {
      const { data: s } = await api.get("/auth/status");
      if (!s.setup_complete) { setStatus("setup"); setUser(null); return; }
      try {
        const { data: me } = await api.get("/auth/me");
        setUser(me); setStatus("authed");
      } catch {
        setUser(null); setStatus("guest");
      }
    } catch {
      setStatus("guest");
    }
  };

  useEffect(() => { bootstrap(); }, []);

  const login = async (username, password) => {
    const { data } = await api.post("/auth/login", { username, password });
    setUser(data.user); setStatus("authed");
    return data.user;
  };
  const setup = async (username, password, name) => {
    const { data } = await api.post("/auth/setup", { username, password, name });
    setUser(data.user); setStatus("authed");
    return data.user;
  };
  const logout = async () => {
    try { await api.post("/auth/logout"); } catch (e) { void e; }
    setUser(null); setStatus("guest");
  };
  const refresh = () => bootstrap();

  return (
    <AuthCtx.Provider value={{ user, status, login, setup, logout, refresh, isOwner: user?.role === "owner" }}>
      {children}
    </AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);
